package ru.villawonka.app.presentation.screens.searchFilter.compose.view

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.filledButtonSecondaryContentInverted
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.design.theme.surfaceMiddle
import ru.villawonka.app.presentation.screens.searchFilter.compose.SearchFilterCallbacks
import ru.villawonka.app.resources.AppResources

@Composable
internal fun SearchFilterTopBar(callbacks: SearchFilterCallbacks) {
    Row(
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .background(MaterialTheme.colors.surfaceMiddle)
            .padding(16.dp)
    ) {
        Text(
            text = AppResources.strings.searchFilterTopBarClear,
            style = AppTextStyles.labelLargeBold,
            color = MaterialTheme.colors.filledButtonSecondaryContentInverted,
            modifier = Modifier.clickable(
                interactionSource = null,
                indication = null
            ) {
                callbacks.onClearButtonClick()
            }
        )
        Text(
            text = AppResources.strings.searchFilterTopBarTitle,
            style = AppTextStyles.titleSmallBold,
            color = MaterialTheme.colors.onSurfacePrimary
        )
        Text(
            text = AppResources.strings.searchFilterTopBarClose,
            style = AppTextStyles.labelLargeBold,
            color = MaterialTheme.colors.filledButtonSecondaryContentInverted,
            modifier = Modifier.clickable(
                interactionSource = null,
                indication = null
            ) {
                callbacks.onCloseButtonClick()
            }
        )
    }
}